import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styles from "./SettingsTutorial.module.scss";
import SonicLink from "../../../common/routing/SonicLink";

type Props = {
  img_src: string;
  title: string;
  explanation: string;
  link?: string;
  link_text?: string;
};
const SettingsTutorial: React.FC<Props> = ({
  img_src,
  title,
  explanation,
  link,
  link_text,
}) => {
  return (
    <div className={styles["settingsTutorial"]}>
      <div className={styles["settingsTutorial__wrapper"]}>
        <div className={styles["settingsTutorial__wrapper__img"]}>
          <img src={img_src} />
        </div>
        <div className={styles["settingsTutorial__wrapper__textBox"]}>
          <h2 className={styles["settingsTutorial__wrapper__textBox__title"]}>
            {title}
          </h2>
          <p className={styles["settingsTutorial__wrapper__textBox__text"]}>
            {explanation}
          </p>
          <div className={styles["settingsTutorial__wrapper__textBox__link"]}>
            <SonicLink
              to="/info/guide"
              className={
                styles["settingsTutorial__wrapper__textBox__link__wrapper"]
              }
            >
              ご利用ガイドへ
              <FontAwesomeIcon icon={["fas", "chevron-right"]} />
            </SonicLink>
          </div>
        </div>
      </div>
      {link && link_text ? (
        <div className={styles["settingsTutorial__wrapper__link"]}>
          <SonicLink to={link}>{link_text}</SonicLink>
        </div>
      ) : null}
    </div>
  );
};

export default SettingsTutorial;
